"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUtxoChainId = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const isUtxoChainId = (chainId) => (0, caip_1.fromChainId)(chainId).chainNamespace === caip_1.CHAIN_NAMESPACE.Utxo;
exports.isUtxoChainId = isUtxoChainId;
